"use client";
import { Copy } from "lucide-react";
import { useTranslations } from "next-intl";
import { addMessage } from "@/components/Messages";
import { Button, type ButtonProps } from "@/components/ui/button";

export const CopyTranscriptButton = ({
  transcriptId,
  ...props
}: ButtonProps & {
  transcriptId: string;
}) => {
  const t = useTranslations();

  return (
    <Button
      {...props}
      onClick={async () => {
        const transcriptText = document.getElementById(transcriptId)?.textContent;
        try {
          if (!navigator.clipboard || !transcriptText) throw new Error("Transcript unavailable");
          await navigator.clipboard.writeText(
            transcriptText + `\n\n${t("podcasts.copiedTextDisclaimer")}`
          );
          addMessage({
            text: t("general.copySuccessMessage"),
            type: "SUCCESS",
          });
        } catch {
          addMessage({
            text: t("general.copyErrorMessage"),
            type: "ERROR",
          });
        }
      }}
    >
      <Copy />
      &nbsp; {t("transcriptionJob.copyTranscriptionButton")}
    </Button>
  );
};
